import DOMPurify from 'dompurify';

export const PurifyText = (text: string) => DOMPurify.sanitize(text);